import userIcon from '../../assets/svg/card-login-ic.svg'
import icEye from '../../assets/svg/iconamoon_eye.svg'
import loginIc from '../../assets/svg/ic-login.svg'
import icPasswprd from '../../assets/svg/auth/ic-eye-password.svg'
import ForgotPassword from '../auth/ForgotPassword';
import axiosClient from '../../../axios-client.js';
import { useStateContext } from '../../context/ContextProvider.jsx';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Helmet } from 'react-helmet';


const Login = () => {
    const [userEmail, setuserEmail] = useState('')
    const [password, setPassword] = useState('')
    const [ showPassword, setShowPassword ] = useState(false);
    const [ metTitle, setMetaTitle ] = useState('');
  const [ metaDescription, setMetaDescription ] = useState('');


  useEffect(() => {
    appSettings();
  }, []);

    const [showModal, setShowModal] = useState(false);
    const [msgtError, setMsgError] = useState();

    const clearErrors = () => {
        setMsgError('');
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    const { setUser, setToken } = useStateContext()
    const [message, setMessage] = useState(null)

    const errNotify = ({ msgErr }) => {
        toast.error(`${msgErr}`, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    };

    const onSubmit = ev => {
        ev.preventDefault()

        const payload = {
            email: userEmail,
            password: password,
        }
        axiosClient.post('/login?', payload)
            .then(({ data }) => {
                clearErrors();
                if (data.data.roles == '') {
                    errNotify({ msgErr: data.message })
                    return false
                } else {
                    setUser(data.data)
                    setToken(data.data.token);
                    window.location.href = '/new-message'; 
                }
            }).catch(err => {
                const response = err.response.data;
                // console.log(response.message.error)
                if (response) {
                    setMsgError(response.message.error);
                } else {
                    console.error('Unexpected error response format:', response);
                }
            })
    }

    const appSettings = () => {
        axiosClient.get('/app-settings')
          .then(({ data }) =>
          {
            setMetaTitle(data.data.title)
            setMetaDescription(data.data.description);
          })
          .catch(() =>
          {
            setLoading(false)
          })
    }

    return (
        <>
            <Helmet>
                <title>Login | { metTitle }</title>
                <meta name="description" content={ metaDescription } />
                <meta name="keywords" content="WhatsApp Business, Customer Service, Automations, Broadcasts, AI Chatbots, Lead Qualification" />
            </Helmet>
            <div className='container'>
                {/* <ToastContainer /> */}
                <ForgotPassword show={showModal} handleClose={handleCloseModal} />
                <div className='row justify-content-center align-items-center'>
                    <div className='col-md-6 my-5 px-1'>
                        <div className='card bg-white border justify-content-center align-items-center'>
                            <img width={52} height={52} className='ic-card mx-auto' src={userIcon} />
                            <h1 className='text-center title my-3'>Sign in</h1>
                            <div className='divider my-4'></div>
                            <form onSubmit={onSubmit} className='text-start py-3 col-md-8'>
                                <div className='form-group py-1'>
                                    <label className='mb-1' htmlFor='userEmail'>E-mail Address</label>
                                    <input className='form-control rounded-pill'
                                        value={userEmail}
                                        placeholder='E-mail Address'
                                        onClick={clearErrors}
                                        onChange={(e) => setuserEmail(e.target.value)}
                                    />
                                </div>
                                <div className='form-group py-1 mt-4'>
                                    <label className='mb-1 d-flex' htmlFor='password'>
                                        <span>Password</span>
                                        <span onClick={handleShowModal} className='ms-auto border-0 forgot-password'>Forgot your password?</span>
                                    </label>
                                    <div className='password-input d-flex justify-content-center align-items-center' >
                                        <input
                                            className='password-input form-control rounded-pill'
                                            type={showPassword ? 'text' : 'password'}
                                            value={password}
                                            placeholder='Password'
                                            onClick={clearErrors}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <span className='ic-shor-password toggle-password-visibility'
                                            onClick={togglePasswordVisibility}>
                                            <img width={24} height={24} className='ic-ey' src={showPassword ? icPasswprd : icEye} />
                                        </span>
                                    </div>
                                </div>

                                <div className={`${!msgtError ? 'd-none' : 'd-block'} alert alert-danger my-2`} role="alert">
                                    {/* <ul>
                                        {msgtError && msgtError.map((error, index) => (
                                            <li key={index}>{error}</li>
                                        ))}
                                    </ul> */}
                                    {msgtError}
                                </div>

                                <div className='d-flex'>
                                    <input className='btn-login my-4 px-5 rounded-pill' type='submit' value='Connexion' />
                                    <img width={38} height={38} className='ic-eye' src={loginIc} />
                                </div>
                            </form>

                            <div className='my-5 d-flex'>
                                <p className='fw-bolder txt-gray'>Are you a new user ? </p>
                                <a className='fw-bolder mx-2' href='/signup'>Sign Up</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}



export default Login